<style scoped>
    /*
    .modal-enter, .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .ks-modal-dialog,
    .modal-leave-active .ks-modal-dialog {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
    */

    .ks-modal-dialog .ks-modal-body {
        overflow-y: auto
    }
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,.5);
        display: table;
        /*transition: opacity .3s ease;*/
    }
    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }
    .ks-modal-dialog {
        margin: 0 auto;
        /*-webkit-transition: all .1s ease;
        transition: all .1s ease;*/
    }
    .ks-dialog-loading{
        display: inline-block;
        width: 16px;
        height: 16px;
        line-height: 16px;
        text-align: center;
    }
    .ks-dialog-loading .fa {
        color: #fff;
        font-size: 20px;
    }


</style>

<template>
    <transition
            @before-enter='transitionBeforeEnter'
            @enter='transitionEnter'
            @leave='transitionLeave'>
        <div class="modal-mask" v-show="show">
            <div :class="'modal-wrapper ks-modal-' + type">
                <div class="ks-modal-dialog">
                    <div class="ks-modal-content">
                        <div class="ks-modal-header">
                            <a href="javascript:void(0)" class="close">
                                <span class="icon icon-close-20"
                                      @click="dispatch($event, 'on-' + btn + '-close')"></span>
                            </a>
                            <h2 class="ks-modal-title">
                                {{ title }}
                            </h2>
                        </div>
                        <div class="ks-modal-body">
                            <slot>

                            </slot>
                        </div>
                        <div class="ks-modal-footer">
                            <button type="button"
                                    :class="'ks-btn ' + getClassName"
                                    id="ks_dialog_btnok"
                                    :disabled="isLoading || btnDisabled"
                                    @click="dispatch($event,  'on-' + btn + '-ok')">
                                    <span v-show="!isLoading">
                                        {{button}}
                                    </span>
                                <span class="ks-dialog-loading" v-show="isLoading">
                                    <i class="fa fa-spin fa-spinner"></i>
                                </span>
                            </button>
                            <button type="button"
                                    v-if="cancel!='hidden'"
                                    @click="dispatch($event, 'on-' + btn + '-close')"
                                    class="ks-btn ks-btn-default">
                                {{$trans(`取消`)}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

    /*
     使用event hub的方式处理1.0的dispatch问题
     */
    import EventHub from '../../services/EventHub';
    import Velocity from 'velocity-animate'

    import Vue from 'vue';
    export default {
        name: 'Dialog',
        data (){
            return {
//                isLoading: false
            }
        },
        props: {
            type: {
                type: String,
                required: false
            },
            title: {
                type: String,
                required: true
            },
            show: {
                type: Boolean,
                required: true
            },
            isLoading: {
                type: Boolean,
                required: false,
                default: false
            },
            loading: {
                type: String
            },
            time: {
                type: String
            },
            btn: {
                type: String,
                required: false
            },
            button: {
                type: String,
                required: false,
                default: Vue.$trans(`确定`)//'确定'
            },
            cancel: {
                type: String,
                required: false,
                default: 'show'
            },
            classname: {
                type: String
            },
            btnDisabled: {
                type: Boolean,
                required: false,
                default: false
            }
        },

        computed: {

            getClassName() {
                var me = this;
                if (me.classname) {
                    if (me.classname === 'ks-btn-warnning') {
                        if (me.btnDisabled) {
                            return 'ks-btn-warning-disabled'
                        }
                    }

                    return me.classname;
                }

                if (me.btnDisabled) {
                    return 'ks-btn-primary-disabled';
                }
                return 'ks-btn-primary';

            }

        },

        watch: {
            show() {
                var me = this;
                me.isLoading = false;
                if (me.show) {
                    // 打开弹窗dialog，根据窗口大小计算dialog-body的max-height，避免dialog高度超过窗口最大值
                    me.$nextTick(() => {
                        var windowHeight = $(window).height();
                        var el = $(me.$el);
                        var topHeight = el.find('.ks-modal-header').outerHeight();
                        var bottomHeight = el.find('.ks-modal-footer').outerHeight();
                        var padding = 40;
                        var h = windowHeight - topHeight - bottomHeight - padding;
                        el.find('.ks-modal-body').css('max-height', h + 'px');
                    });
                } else {
                    me.isLoading = false;
                }
            },
            isLoading() {
            }
        },

        created (){
//            this.$watch('show', function(){
//            });
        },

        methods: {

            transitionBeforeEnter(el) {
                let box = $(el).find('.ks-modal-dialog').get(0);
            },
            transitionEnter(el, done) {
                let box = $(el).find('.ks-modal-dialog').get(0);
                Velocity(el, {
                    opacity: 1
                });
                Velocity(box, {
                    translateY: '10px',
                    opacity: 1
                }, { complete: done });
            },
            transitionLeave(el, done) {
                let box = $(el).find('.ks-modal-dialog').get(0);
                Velocity(box, {
                    translateY: '-10px',
                    opacity: 0
                });
                Velocity(el, {
                    opacity: 0
                }, { complete: done});
            },

            dispatch(event, eventStr) {
                var that = this;
                if(this.loading === 'yes' && (event.target.id === 'ks_dialog_btnok' || event.target.parentNode.id === 'ks_dialog_btnok')){
                    this.isLoading = true;
//                    setTimeout(function(){
//                        that.isLoading = false;
//                    }, this.time || 30000);
                }
                EventHub.$emit(eventStr);
            }
        }
    }


</script>
